<template>
  <!-- <v-card
    class="mx-auto start-card"
    max-width="400"
    color="#EEEEFF"
  > -->
  <div id="version-record" class="my-4">
    <v-card
      class="mx-auto"
      width="400"
      color="rgba(0,0,0,0)"
      elevation=0
      @mouseover="mouseover"
      @mouseleave="mouseleave"
    >
      <p v-if="selected!='version'&&changeHover" style="font-size:20px;background-color:rgba(0,0,0,0.1);color:#FFFFFF;padding: 12px 0;cursor:pointer;" v-on:click="pushed"><b>バージョン履歴</b></p>
      <p v-else-if="selected!='version'" style="font-size:20px;color:#FFFFFF;padding: 12px 0;cursor:pointer;" v-on:click="pushed"><b>バージョン履歴</b></p>
      <p v-else style="background-color:rgba(0,0,0,0.2);font-size:20px;color:#FFFFFF;"><b>バージョン履歴</b></p>
    </v-card>
    <v-expand-transition>
      <v-card
        v-if="selected=='version'"
        class="mx-auto mt-n4"
        elevation=0
        width="400"
        color="rgba(0,0,0,0.2)"
      >
      <div class="mx-auto my-auto" style="width:360px; padding: 12px 0">
        <!-- <v-simple-table dark> -->
          <template>
            <tbody>
              <tr>
                <td style="width:100px"><p><b>1.0.0</b></p></td>
                <td style="text-align:left"><p>サービス開始．(2020/07/19)</p></td>
              </tr>
            </tbody>
          </template>
        <!-- </v-simple-table> -->
      </div>
      </v-card>
    </v-expand-transition>
  </div>
  <!-- </v-card> -->
</template>
<script>
export default {
  props: ['selected'],
  data() {
    return {
      changeHover: false
    }
  },
  methods:{
    pushed() {
      if (this.selected != 'version'){
        // this.selected = 'report'
        this.$emit("select-mode", {selected: "version"})
      }else {
        // this.selected = ''
        this.$emit("select-mode", {selected: ""})
      }
    },

    mouseover: function(){
      this.changeHover = true
    },
    mouseleave: function(){
      this.changeHover = false
    },
  }
}
</script>
<style>
#version-record p {
  color: #FFF;
}
</style>
